export const AD_IMAGE_PLACEHOLDER = `data:image/svg+xml;utf8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800" role="img" aria-label="Aucune image">
    <defs>
      <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#eef3f8"/>
        <stop offset="100%" stop-color="#dfe7ef"/>
      </linearGradient>
    </defs>
    <rect width="1200" height="800" fill="url(#bg)"/>
    <rect x="220" y="160" width="760" height="480" rx="28" fill="#f8fbfe" stroke="#b8c7d6" stroke-width="10"/>
    <circle cx="430" cy="320" r="54" fill="#c8d6e5"/>
    <path d="M300 560l145-145c18-18 48-18 66 0l78 78 116-116c18-18 48-18 66 0l129 183H300z" fill="#c8d6e5"/>
    <path d="M300 560h600" stroke="#9fb2c4" stroke-width="10" stroke-linecap="round"/>
  </svg>`
)}`;
